export const MODAL_TYPE = {
  DEFAULT: 'default',
  ERROR: 'error',
}
